import React from 'react';

/**
 * Editorial input field used in branding/text settings. Shows a "Custom"
 * badge when the value differs from the default, plus a quiet "Use default"
 * action that resets the field. Used in both UserSettings (per-owner texts)
 * and AdminDemoExperience (demo template texts).
 */
const SettingsWelcomeField = ({
  label,
  testId,
  value,
  onChange,
  defaultValue,
  isCustom,
  onUseDefault,
  placeholder,
  multiline = false,
  t = {},
}) => {
  const Tag = multiline ? 'textarea' : 'input';
  const fieldStyle = {
    padding: '10px 14px',
    fontSize: '14px',
    width: '100%',
    boxSizing: 'border-box',
    border: `1px solid ${isCustom ? 'var(--kahla-charcoal)' : 'var(--kahla-border)'}`,
    fontFamily: 'inherit',
    ...(multiline ? { resize: 'vertical', minHeight: '60px' } : {}),
  };
  return (
    <div>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '8px',
        marginBottom: '6px',
      }}>
        <label style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          fontSize: '12px',
          color: 'var(--kahla-text-light)',
        }}>
          {label}
          {isCustom && (
            <span
              data-testid={`${testId}-custom-badge`}
              style={{
                fontSize: '9px',
                letterSpacing: '0.18em',
                textTransform: 'uppercase',
                color: 'var(--kahla-charcoal)',
                border: '1px solid var(--kahla-charcoal)',
                padding: '2px 6px',
                lineHeight: 1,
              }}
            >
              {t.custom_label || 'Custom'}
            </span>
          )}
        </label>
        {isCustom && (
          <button
            type="button"
            data-testid={`${testId}-use-default-btn`}
            onClick={onUseDefault}
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              fontSize: '11px',
              color: 'var(--kahla-taupe)',
              cursor: 'pointer',
              fontFamily: 'inherit',
              textDecoration: 'underline',
              textDecorationColor: 'rgba(166,152,136,0.4)',
              textUnderlineOffset: '3px',
              transition: 'color 0.2s',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.color = 'var(--kahla-charcoal)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.color = 'var(--kahla-taupe)'; }}
          >
            {t.use_default || 'Use default'}
          </button>
        )}
      </div>
      <Tag
        data-testid={testId}
        type={multiline ? undefined : 'text'}
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder || ''}
        rows={multiline ? 2 : undefined}
        style={fieldStyle}
      />
    </div>
  );
};

export default SettingsWelcomeField;
